import { render, staticRenderFns } from "./TitleDropdownMenu.vue?vue&type=template&id=264a84cf"
import script from "./TitleDropdownMenu.vue?vue&type=script&lang=js"
export * from "./TitleDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./TitleDropdownMenu.vue?vue&type=style&index=0&id=264a84cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports